import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { BCLedgerFilter } from "../../../../core/models/bcLedgers/bclegderfilter";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { exportExcel } from "../../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { YtdSummaryData } from "../../../../core/models/bcLedgers/ytdSummaryDataDto";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { YTDGPComponent } from "../ytdgp/ytdgp.component";
import { BacklogDetailsComponent } from "../backlog-details/backlog-details.component";

@Component({
  selector: "jni-year-to-date-summary",
  templateUrl: "./year-to-date-summary.component.html",
  styleUrls: ["./year-to-date-summary.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    CardModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    ModalStackerComponent,
    YTDGPComponent,
    BacklogDetailsComponent,
  ],
})
export class YearToDateSummaryComponent {
  bcLedgerStacker: BcLedgerStacker = {} as BcLedgerStacker;
  displayModal = false;
  @Output() populate = new EventEmitter<BcLedgerStacker>();
  @Input() yearToDateSummaryLists!: YtdSummaryData[];
  @Input() bcLedgerFilter!: BCLedgerFilter;
  @Input() isFromDashboard = false;
  @Input() currentSupportPercentage = 0;
  @Input() nextCommissionTier = 0;
  @Input() nextToGpCommission = 0;
  @Input() rollingTwelveMonthGp = 0;
  @Input() isFromBcReport = false;
  @Input() rollingTwelveMonthRevenue = 0;
  category = "portal";
  fileName = "YTD Summary";

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    exportExcel(this.yearToDateSummaryLists, this.fileName);
  }

  onStackingRedirect(
    path: string,
    brandingConsultantID: string,
    fromDate: string,
    toDate: string,
    CategoryID: string
  ) {
    fromDate = new Date(
      this.bcLedgerFilter.fromDate ?? ""
    ).toLocaleDateString();
    toDate = new Date(this.bcLedgerFilter.toDate ?? "").toLocaleDateString();

    path = path.replace(/[^a-zA-Z ]/g, "").replace(/\s/g, "");

    this.bcLedgerStacker.Path = path;
    this.bcLedgerStacker.BrandingConsultantID = brandingConsultantID ?? "";
    this.bcLedgerStacker.FromDate = fromDate;
    this.bcLedgerStacker.ToDate = toDate;
    this.bcLedgerStacker.CategoryID = CategoryID;
    this.displayModal = true;
    this.populate.emit(this.bcLedgerStacker);
  }

  closeBcLedgerModal() {
    this.displayModal = false;
  }
}
